module.exports = __webpack_public_path__ + "static/media/perso2.90eed808.webp";